import CreatorInformation from 'components/desktop/detail/main-section/main-section-right/creator-information';
import SameInDistrictList from 'components/desktop/detail/main-section/main-section-right/same-in-district-list';
import SameInProvinceList from 'components/desktop/detail/main-section/main-section-right/same-in-province-list';

const MainSectionRight = () => (
  <div
    id='main-section-right'
    className='sticky top-[92px] flex h-full w-[380px] min-w-[380px] flex-col space-y-[28px]'
  >
    <CreatorInformation />
    <SameInDistrictList />
    <SameInProvinceList />
    {/* <AdvertismentList /> */}
  </div>
);

export default MainSectionRight;
